var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.82,
    height: 31.82,
    viewBox: "0 0 31.82 31.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-icon",
    transform: "translate(-64.229 -15.271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4004",
    "data-name": "Ret\\xE2ngulo 4004",
    width: 39,
    height: 6,
    rx: 3,
    transform: "translate(64.229 42.848) rotate(-45)",
    fill: "#5d00c3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4005",
    "data-name": "Ret\\xE2ngulo 4005",
    width: 39,
    height: 6,
    rx: 3,
    transform: "translate(91.806 47.091) rotate(-135)",
    fill: "#5d00c3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.96a1d486ab880b0649799067d35cffb9.svg";
export { ForwardRef as ReactComponent };